export default __webpack_public_path__ + "static/media/back-arrow.670da770.svg";